import { v4 as uuid } from "uuid";

import { EntityTypes } from "../../EntityTypes";
import { ISkillBlockResource } from "../../skill-blocks";
import { ISkillDomainResource } from "../../skill-domains";
import { ISkillResource } from "../../skills";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapOrderedRelationAsIRIs, RelationalValue } from "../../utils/filters";
import { IFramework, IFrameworkRncpRecord } from "../types";

export type IFrameworkCreateMutationParameters = {
    title: string;
    shortIdentifier: string;
    rncpId?: string;
    rncpRecord?: IFrameworkRncpRecord;
    skills?: RelationalValue<ISkillResource>[];
    skillDomains?: RelationalValue<ISkillDomainResource>[];
    skillBlocks?: RelationalValue<ISkillBlockResource>[];
    uuid?: string;
};

export type IFrameworkCreateMutationResult = IFramework;

/** An absent record clears the three dates, which the api only accepts as explicit nulls. */
export const mapRncpRecord = (record?: IFrameworkRncpRecord) => ({
    rncpPublicationDate: record?.rncpPublicationDate ?? null,
    rncpCertifyingPathStartDate: record?.rncpCertifyingPathStartDate ?? null,
    rncpRegistrationExpiryDate: record?.rncpRegistrationExpiryDate ?? null,
});

export const frameworkCreateMutation: IApiMutationFunction<IFrameworkCreateMutationParameters> = ({
    uuid: providedUuid,
    title,
    shortIdentifier,
    rncpId,
    rncpRecord,
    skills,
    skillDomains,
    skillBlocks,
}) => {
    return {
        method: "POST",
        url: "/frameworks",
        data: {
            title,
            shortIdentifier,
            rncpId,
            ...mapRncpRecord(rncpRecord),
            skills: mapOrderedRelationAsIRIs(EntityTypes.SKILL, skills),
            skillDomains: mapOrderedRelationAsIRIs(EntityTypes.SKILL_DOMAIN, skillDomains),
            skillBlocks: mapOrderedRelationAsIRIs(EntityTypes.SKILL_BLOCK, skillBlocks),
            uuid: providedUuid ?? uuid(),
        },
    };
};

export const useFrameworkCreateMutation = createApiMutationHook<
    IFrameworkCreateMutationParameters,
    IFrameworkCreateMutationResult
>(frameworkCreateMutation);
